import { TABLE_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers-lazy.js";
const pluginTable = (config = {}) => {
  return {
    config,
    type: TABLE_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginTable
};
//# sourceMappingURL=viewer-lazy.js.map
